var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5254,
    cy: 16.5,
    r: 16.5,
    fill: "#41B7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8254 10.9046C26.0975 11.228 25.3141 11.4458 24.4924 11.5441C25.3312 11.0412 25.9754 10.2453 26.2783 9.29698C25.4943 9.76291 24.6238 10.1001 23.6992 10.283C22.958 9.49365 21.9015 9 20.734 9C18.4908 9 16.672 10.8188 16.672 13.062C16.672 13.3801 16.7083 13.6903 16.7776 13.9879C13.4012 13.819 10.4083 12.2014 8.4047 9.74377C8.05492 10.3437 7.85496 11.0412 7.85496 11.7857C7.85496 13.1947 8.57101 14.438 9.66191 15.1666C8.99536 15.1455 8.36972 14.9627 7.8213 14.6585V14.7093C7.8213 16.6779 9.22238 18.3192 11.0795 18.6934C10.739 18.7858 10.3799 18.836 10.0097 18.836C9.74771 18.836 9.49297 18.8102 9.24482 18.7627C9.76157 20.3763 11.2623 21.551 13.0396 21.584C11.6497 22.673 9.89818 23.323 7.99486 23.323C7.66621 23.323 7.34283 23.3039 7.02539 23.2656C8.82311 24.4179 10.9581 25.091 13.2521 25.091C20.7234 25.091 24.8092 18.9013 24.8092 13.5339C24.8092 13.3577 24.8059 13.1821 24.7973 13.0086C25.5919 12.4344 26.2809 11.719 26.8254 10.9046Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.df66af9f59c115286e658e9e32a85030.svg";
export { ForwardRef as ReactComponent };